import { arcadeSettingsResponseSchema } from '@/api/resources/shared/arcade'
import { z } from 'zod'

export const arcadeSettingsInputSchema = z.object({
  season_id: z.number(),
  time_start: z.string(),
  time_end: z.string(),
  rank_threshold: z.string()
})

export const setArcadeSettingsResponseSchema = z.object({
  season: arcadeSettingsResponseSchema
})

export type ArcadeSettingsInput = z.infer<typeof arcadeSettingsInputSchema>
export type ArcadeSettingsResponse = z.infer<
  typeof setArcadeSettingsResponseSchema
>
